"use strict";

import { gsap } from "gsap";
import main from "../css/sass/main.scss";
import inline from "../css/sass/inline.scss";

import headerScrolling from "./scripts/headerScrolling";
import mobileMenu from "./scripts/mobileMenu";
import inputSelect from "./scripts/inputSelect";
import parallax from "./scripts/parallax";
import accordion from "./scripts/accordion";
import sliderHero from "./scripts/pages/home/sliderHero";
import especialidadesSlider from "./scripts/pages/home/especialidadesSlider";
import testimonialsSlider from "./scripts/pages/home/testimonialsSlider";
import aboutSlider from "./scripts/pages/home/aboutSlider";
import blogSlider from "./scripts/pages/home/blogSlider";
import filterArchiveNeuro from "./scripts/filterArchiveNeuro";
import heroSlider from "./scripts/pages/blog/heroSlider";
import gsapAnimations from "./scripts/gsapAnimations";
import initGsapMarquee from "./scripts/pages/qm-somos/infinitBanner";
import faqAccordion from "./scripts/pages/convenios/faqAccordion";
import especialidadesUnidade from "./scripts/pages/convenios/especialidades";

window.gsap = gsap;

headerScrolling();
mobileMenu();
inputSelect();
parallax();
accordion();
sliderHero();
especialidadesSlider();
testimonialsSlider();
aboutSlider();
blogSlider();
filterArchiveNeuro();
heroSlider();
gsapAnimations();
initGsapMarquee();

faqAccordion();
especialidadesUnidade();
